import React, { Suspense }	from 'react';
import PropTypes        	from 'prop-types';

const LazyComponent = ({ fallback = '', component, children }) => {
	const data = component ? component : children;

	return (
		<Suspense fallback={fallback}>
			{data}
		</Suspense>
	);
};

LazyComponent.propTypes = {
	fallback: PropTypes.string,
	component: PropTypes.any,
	children: PropTypes.any,
};

export default LazyComponent;
